module.exports = __webpack_public_path__ + "img/thumb_Piazza_San_Marco.ba7d3627.jpg";